import { Controller } from "@hotwired/stimulus"

// While the AI is still making a summary or a draft (docs/crm/ai.md), the
// frame around this element reloads from `src` every few seconds; the
// answer replaces the element, so polling stops by itself once it is done
// (or failed), and when the page is left.
export default class extends Controller {
  static values = { src: String, interval: { type: Number, default: 3000 } }

  connect() {
    this.timer = setTimeout(() => this.reload(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  reload() {
    const frame = this.element.closest("turbo-frame")
    if (!frame || !this.srcValue) return

    const url = new URL(this.srcValue, window.location.href).href
    if (frame.src === url) {
      frame.reload()
    } else {
      frame.src = url
    }
  }
}
